import React from "react"
import { reduxForm } from "redux-form"
import FieldWrapper from "components/FieldWrapper"
import { Button, TYPES } from "components/Button"

class CategoryForm extends React.Component {
  render() {
    const { handleSubmit, submitText } = this.props 
    return (
      <form onSubmit={handleSubmit}>
        <FieldWrapper
          label="Kategori"
          name="categoryName"
          placeholder="Exempel: Snickare"
          component="input"
          type="text"
        />
        <Button buttonType={TYPES.SUCCESS}>{submitText}</Button>
      </form>
    )
  }
}

CategoryForm = reduxForm({
  form: "categoryForm",
})(CategoryForm)

export default CategoryForm



// WEBPACK FOOTER //
// src/components/CategoryForm/index.jsx